import { Input } from "antd";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import LabelRequired from "../../components/Common/LabelRequired";
import { PaymentStatusLabel } from "../../enum/lisence";
import { DataType } from "../../models/interface/license.interface";
import { api } from "../../utils/api";
import { formatDate } from "../../utils/date";

const fields = [
  { label: "Agent name", name: "assignedAgent" },
  { label: "End User (Clinic) Name", name: "assignedCustomer" },
  {
    label: "Name of person in charge of the agency",
    name: "agencyContactPerson",
  },
  { label: "End user contact name", name: "userContactName" },
  { label: "Agency contact email address", name: "agencyEmail" },
  { label: "End user contact email address", name: "userContactEmail" },
  { label: "カメラシリアルナンバー", name: "cameraSerial" },
  { label: "HWシリアルナンバー", name: "assignedDeviceSerial" },
  { label: "キー", name: "maskedCode" },
  { label: "決済ステータス", name: "paymentStatus" },
  { label: "有効期限", name: "expiresAt" },
  {
    label: "Email address to send download information",
    name: "notificationEmail",
  },
  { label: "申請日", name: "requestedAt" },
  { label: "HW Signature", name: "hardwareSignature" },
];

function AdminLisenceDetailPage() {
  const [data, setData] = React.useState<DataType | null>(null);
  const { control, reset } = useForm();
  const { id } = useParams();

  const getDetailLicense = async () => {
    const res = await api.get(`/api/licenses/${id}`);
    setData(res.data);
  };

  useEffect(() => {
    getDetailLicense();
  }, []);

  useEffect(() => {
    reset({
      ...data,
      paymentStatus:
        data?.batch?.paymentStatus &&
        PaymentStatusLabel[data?.batch?.paymentStatus],
      purchaseDate: data?.batch?.purchaseDate,
      expiresAt: data?.expiresAt ? formatDate(data.expiresAt) : "",
      requestedAt: data?.requestedAt ? formatDate(data.requestedAt) : "",
    });
  }, [data]);

  return (
    <div>
      <div className="p-1 text-sm font-normal bg-[#0077C8] text-white w-fit">
        Information
      </div>
      <div className="grid grid-cols-2 gap-x-6 gap-y-4 mt-2">
        {fields.map((field) => (
          <div key={field.label} className="flex flex-col">
            <LabelRequired required={false} text={field.label} />
            <Controller
              name={field.name}
              control={control}
              render={({ field }) => (
                <div>
                  <Input
                    {...field}
                    type="text"
                    className="w-full h-[46px]"
                    value={field.value || ""}
                    disabled
                  />
                </div>
              )}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default AdminLisenceDetailPage;
